import React, { Component, Fragment } from "react";
import {
  Menu,
  Button,
  Form,
  Statistic,
  Container,
  Pagination,
  Accordion,
} from "semantic-ui-react";
import { translate } from "react-i18next";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { withApollo } from "@apollo/react-hoc";

import PreloadTable from "../../components/preload/PreloadTable";
import gql from "graphql-tag";
import { isJsonEmpty } from "../../store/functionUtils";

class Preload extends Component {
  constructor(props) {
    super(props);
    this.state = {
      valueSearch: "",
      preloadData: [],
      total: 0,
      totalPages: 1,
      page: 1,
      filter: -1,
      filterOptions: [
        { value: -1, text: props.t("PRLD_DROP_ALL") },
        { value: 0, text: props.t("PRLD_DROP_PRIVATE") },
        { value: 1, text: props.t("PRLD_DROP_PRIVACY") },
      ],
      filterTeam: props.teamDefault,
      filterStaff: props.user.idstaff,
    };
  }

  componentDidMount() {
    // Set the options for the filter
    let localFilter = this.state.filterOptions;
    if (this.props.user.user_permissions.can_manage_preload) {
      localFilter.push({ value: 2, text: this.props.t("PRLD_DROP_TEAM") });
      if (this.props.user.user_permissions.can_manage_staff) {
        localFilter.push({ value: 3, text: this.props.t("PRLD_DROP_STAFF") });
      }
    }

    this.setState({ filterOptions: localFilter });
  }

  // Handle change filter value
  dropdownChange(e, data) {
    this.setState({ filter: data.value, page: 1 });
  }

  // Handle change of search input bar
  handleValue(event) {
    this.setState({ valueSearch: event.target.value.toLowerCase() });
  }

  // Handle enter key in search bar
  handleEnter(event) {
    if (event.keyCode === 13) {
      event.preventDefault();
      this.search(null, false);
    }
  }

  // Handle refresh of the page after the delete or the edit of the record
  refreshAfterEditDelete() {
    if (this.state.valueSearch === "") {
      this.displayFullPreload(true);
    } else {
      this.search(null, true);
    }
  }

  // Main search preload
  search(customQuery = null, fromPagination = false, fields = {}) {
    let query;
    let variables = fields;
    if (customQuery) {
      query = customQuery;
    } else if (!isJsonEmpty(fields)) {
      variables = { where: fields };
      query = this.buildQuery(fromPagination);
    } else {
      let where = {};
      where._and = [];
      if (this.state.filter !== -1) {
        where._and.push({ type_img: { _eq: this.state.filter } });
      }
      if (!this.props.user.user_permissions.can_manage_preload) {
        where._and.push({ created_by: { _eq: this.props.user.id } });
      }

      if (this.state.valueSearch.slice(-4) === ".png") {
        where._and.push({
          symbol_sign: { _ilike: this.state.valueSearch.trim() },
        });
      } else {
        if (this.state.valueSearch.trim() !== "") {
          where._and.push({
            voice_master: { _ilike: this.state.valueSearch.trim() },
          });
        }
      }

      if (this.state.filterTeam > 0) {
        where._and.push({ idteam: { _eq: this.state.filterTeam } });
      }

      // if (this.state.filterStaff > 0) {
      //   where._and.push({ idstaff: { _eq: this.state.filterStaff } } );
      // }

      variables = { where };
      query = this.buildQuery(fromPagination);
    }

    this.props.client
      .query({ query, variables })
      .then((data) => {
        let preloadData = data.data.simcaa_t_custom_preload_headword.map(
          (item) => {
            const { with_image, user, staff, team, ...props } = item;
            return {
              ...props,
              with_image,
              username: user.user,
              staff_name: staff.name,
              team_name: team.name,
              origin: with_image === 1 ? "Nuovo Simbolo" : "Associazione",
            };
          }
        );

        const total =
          data.data.simcaa_t_custom_preload_headword_aggregate.aggregate.count;
        this.setState({
          preloadData,
          total,
          totalPages: Math.ceil(total / 15),
          page: fromPagination === true ? this.state.page : 1,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  }

  // display full preload record
  displayFullPreload(fromPagination = false) {
    this.setState({ valueSearch: "" }, () => {
      let where = { _and: [] };
      if (this.state.filter !== -1) {
        // where.type_img = { _eq: this.state.filter };
        where._and.push({ type_img: { _eq: this.state.filter } });
      }
      if (!this.props.user.user_permissions.can_manage_preload) {
        // where.created_by = { _eq: this.props.user.id };
        where._and.push({ created_by: { _eq: this.props.user.id } });
      }

      if (this.state.filterTeam > 0) {
        // where._and.push({ team: { id: { _eq: this.state.filterStaff } } });
        where._and.push({ team: { id: { _eq: this.state.filterTeam } } });
        // where.team = { id: { _eq: this.state.filterTeam } };
      }

      // if (this.state.filterStaff > 0) {
      //   where._and.push({
      //     team: { staff: { id: { _eq: this.state.filterStaff } } }
      //   });
      // }

      this.search(null, fromPagination, where);
    });
  }

  // Create gql query for preload
  buildQuery(fromPagination = false) {
    return gql`
    query fetchPreload($where: simcaa_t_custom_preload_headword_bool_exp) {
      simcaa_t_custom_preload_headword(where: $where, limit: 15, offset: ${
        fromPagination === true ? (this.state.page - 1) * 15 : 0
      }) {
        id
        voice_human
        with_image
        lexical_expr
        idclass
        symbol_sign
        imgcolor
        type_img
        idstyle
        created_by
        share_team
        user {
          user
        }
        staff {
          name
        }
        team {
          name
        }
      }
      simcaa_t_custom_preload_headword_aggregate(where: $where) {
        aggregate {
          count
        }
      }
    }
  `;
  }

  // Handle change page in pagination
  changePagePrelaod(e, activePage) {
    this.setState({ page: activePage.activePage }, () => {
      // if (this.state.valueSearch === "") {
      //   this.displayFullPreload(true);
      // } else {
      //   this.search(null, true);
      // }
      this.search(null, true);
    });
  }

  // delete current preload record
  // deletePreloadRecord(item, e) {
  //   const mutation = gql`
  //     mutation deletePreload {
  //       delete_simcaa_t_custom_preload_headword(where: {id: {_eq: ${item.id}}}) {
  //         affected_rows
  //       }
  //     }
  //   `;

  //   this.props.client
  //     .mutate({ mutation })
  //     .then(data => {
  //       if (this.state.valueSearch === "") {
  //         this.displayFullPreload();
  //       } else {
  //         this.search();
  //       }
  //     })
  //     .catch(error => {
  //       console.log(error);
  //     });
  // }

  // redirect to homepage and clean the chapter list data
  redirectProject() {
    this.props.history.push("/home");
  }

  // MAIN RENDER
  render() {
    const { t } = this.props;

    const teamOptions = this.props.team.map((team) => ({
      key: team.team_id,
      text: team.team_name,
      value: team.team_id,
    }));

    if (this.props.user.user_permissions.can_manage_preload) {
      teamOptions.unshift({ key: 0, text: "Tutti", value: 0 });
    }

    const panels = [
      {
        key: "filter",
        title: t("FLT_FILTER"),
        content: {
          content: (
            <Fragment>
              <Form.Group>
                <Form.Select
                  label={t("PRLD_TBL_TEAM")}
                  options={teamOptions}
                  placeholder={t("PRLD_TBL_TEAM")}
                  value={this.state.filterTeam}
                  onChange={(e, data) =>
                    this.setState({ filterTeam: data.value })
                  }
                />
                <Form.Select
                  disabled
                  label={t("PRLD_TBL_STAFF")}
                  options={teamOptions}
                  placeholder={t("PRLD_TBL_STAFF")}
                  defaultValue={teamOptions[0].value}
                />
                {this.props.user.user_permissions.can_manage_preload ? (
                  <Form.Select
                    label={t("MAIN_TBL_SHARE")}
                    options={this.state.filterOptions}
                    placeholder={t("MAIN_TBL_SHARE")}
                    value={this.state.filter}
                    onChange={this.dropdownChange.bind(this)}
                  />
                ) : null}
              </Form.Group>
              <Button color="blue" onClick={() => this.search()}>
                {t("FLT_FILTER_APPLY")}
              </Button>
            </Fragment>
          ),
        },
      },
    ];

    return (
      <div>
        <Menu>
          <Menu.Item>
            <Button color="red" onClick={this.redirectProject.bind(this)}>
              {t("PRJ_MNU_BACK")}
            </Button>
          </Menu.Item>
        </Menu>
        <Container>
          <Form>
            <Form.Input
              size="large"
              action
              placeholder={t("PRLD_LBL_INPUT_WORD")}
              value={this.state.valueSearch}
              onChange={this.handleValue.bind(this)}
              onKeyDown={this.handleEnter.bind(this)}
            >
              <input />
              <Button color="blue" onClick={() => this.search()}>
                {t("PRLD_LBL_BUTTON_SEARCH")}
              </Button>
              <Button color="teal" onClick={this.displayFullPreload.bind(this)}>
                {t("PRLD_LBL_BUTTON_ALL")}
              </Button>
            </Form.Input>
            <Accordion styled as={Form.Field} panels={panels} fluid />
          </Form>
        </Container>
        <Statistic.Group widths={2}>
          <Statistic color="blue" floated="right">
            <Statistic.Value>{this.state.preloadData.length}</Statistic.Value>
            <Statistic.Label>{t("PRLD_LBL_STATISTIC_LIMIT")}</Statistic.Label>
          </Statistic>
          <Statistic color="blue" floated="right">
            <Statistic.Value>{this.state.total}</Statistic.Value>
            <Statistic.Label>{t("PRLD_LBL_STATISTIC_TOTAL")}</Statistic.Label>
          </Statistic>
        </Statistic.Group>
        <Container textAlign="center">
          <Pagination
            activePage={this.state.page}
            totalPages={this.state.totalPages}
            onPageChange={this.changePagePrelaod.bind(this)}
            style={{ marginTop: "20px" }}
          />
        </Container>
        <PreloadTable
          data={this.state.preloadData}
          refresh={this.refreshAfterEditDelete.bind(this)}
          team={this.props.team}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    team: state.userTeamData,
    teamDefault: state.filterValue,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withApollo(withRouter(translate("translations")(Preload))));



// WEBPACK FOOTER //
// ./src/containers/preload/Preload.js